import { Typography } from '@/shared/ui';
import { Dialog } from '@/shared/ui/Dialog';
import { Button } from '@/shared/ui/lib/Button';

import { TConfirmationDialogProps } from './types';

export const ConfirmationDialog = ({
  onClose,
  onConfirm,
  title,
  rejectText,
  confirmText,
  description,
  isPending,
  priorityButton = 'confirm',
}: TConfirmationDialogProps) => {
  return (
    <Dialog
      open
      onClose={onClose}
      title={title}
      leftButtonSlot={
        <Button
          variant={priorityButton === 'reject' ? 'contained' : 'outlined'}
          onClick={onClose}
        >
          {rejectText}
        </Button>
      }
      rightButtonSlot={
        <Button
          variant={priorityButton === 'confirm' ? 'contained' : 'outlined'}
          onClick={onConfirm}
          loading={isPending}
        >
          {confirmText}
        </Button>
      }
    >
      {typeof description === 'string' ? (
        <Typography sx={{ mb: 2, mt: 2 }} variant="body1">
          {description}
        </Typography>
      ) : (
        description
      )}
    </Dialog>
  );
};
